import { gql } from "@apollo/client";

/** One event's zone / host type / level / capacity / topic-skill labels. */
export const ADMIN_EVENT_INSIGHT = gql`
  query adminEventInsight($eventId: String!) {
    adminEventInsight(eventId: $eventId) {
      zone
      hostType
      level
      visibility
      labelSource
      registered
      maxParticipants
      unlimited
      isFull
      labels {
        key
        name
        family
      }
    }
  }
`;

/** The week's events for the calendar grid — maps to eventsCalendar.resolver.ts. */
export const ADMIN_EVENTS_CALENDAR = gql`
  query adminEventsCalendar($weekStart: String!) {
    adminEventsCalendar(weekStart: $weekStart) {
      weekStart
      total
      events {
        id
        title
        startDate
        zone
        dayOfWeek
        timeUtc
        hostType
        hostFirstName
        hostName
        kind
        level
        category
        visibility
        maxParticipants
        registered
        unlimited
        isFull
        recurring
        isCoachEvent
        needsThreeEvents
        participants
      }
    }
  }
`;
